export default {"src":"/_next/static/media/temple_24.d1a5c89d.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};